import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const ContactUsDetails = () => {
    const [quotes, setQuotes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");

    // Fetch quotes
    const fetchQuotes = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}contactus/all-contact-us`
            );
            const result = await response.json();
            if (result?.status_code === 200) {
                const sortedData = (result.result || []).sort(
                    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                );
                setQuotes(sortedData);
            } else {
                console.error("Failed to fetch quotes:", result?.message);
            }
        } catch (error) {
            console.error("Error fetching quotes:", error);
        }
    };

    useEffect(() => {
        fetchQuotes();
    }, []);

    // Filtering
    const filteredQuotes = quotes.filter((quote) => {
        const query = searchQuery.trim().toLowerCase();
        return (
            quote.firstName?.toLowerCase().includes(query) ||
            quote.lastName?.toLowerCase().includes(query) ||
            quote.emailAddress?.toLowerCase().includes(query) ||
            quote.productName?.toLowerCase().includes(query) ||
            quote.productId?.toLowerCase().includes(query) ||
            quote.userMessage?.toLowerCase().includes(query)
        );
    });

    // Pagination
    const totalPages = Math.ceil(filteredQuotes.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedQuotes = filteredQuotes.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    return (
        <div>
            {/* Breadcrumbs and title */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">Contact Us Details</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link
                            to="/"
                            className="d-flex align-items-center gap-1 hover-text-primary"
                        >
                            <Icon
                                icon="solar:home-smile-angle-outline"
                                className="icon text-lg"
                            />
                            Dashboard
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Contact Us Details</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={filteredQuotes.length}>All</option>
                        </select>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        {/* <div className="icon-field">
                            <input
                                type="text"
                                className="form-control form-control-sm w-auto"
                                placeholder="Search by Name, Email or Subject"
                                onChange={handleSearchChange}
                            />
                            <span className="icon">
                                <Icon icon="ion:search-outline" />
                            </span>
                        </div> */}
                    </div>
                </div>

                <div className="card-body" style={{ overflowX: "auto" }}>
                    <table className="table bordered-table mb-0">
                        <thead>
                            <tr>
                                <th>S.L</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email Address</th>
                                <th>Mobile No</th>
                                <th>State</th>
                                <th>Product</th>
                                <th>Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedQuotes.length === 0 ? (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        No Quotes found.
                                    </td>
                                </tr>
                            ) : (
                                paginatedQuotes.map((quote, index) => (
                                    <tr key={quote._id}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{quote.firstName || "N/A"}</td>
                                        <td>{quote.lastName || "N/A"}</td>
                                        <td>{quote.emailAddress || "N/A"}</td>
                                        <td>{quote.mobileNumber || "N/A"}</td>
                                        <td>{quote.state || "N/A"}</td>
                                        <td>
                                            {quote.productName || "General enquiry"}
                                            {quote.productId && <small className="d-block text-muted">{quote.productId}</small>}
                                        </td>
                                        <td style={{
                                            maxWidth: "250px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                            overflowWrap: "break-word",
                                        }}>{quote.userMessage || "N/A"}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-end align-items-center gap-4 mt-3">
                        <button
                            className="btn btn-sm"
                            onClick={handlePrev}
                            disabled={currentPage === 1}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                                height: "auto",
                            }}
                        >
                            Prev
                        </button>

                        <span>
                            Page {currentPage} of {totalPages || 1}
                        </span>

                        <button
                            className="btn btn-sm"
                            onClick={handleNext}
                            disabled={currentPage === totalPages || totalPages === 0}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                                height: "auto",
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUsDetails;
